import React, { useState, useEffect } from "react";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import CircularProgress from "@mui/material/CircularProgress";
import { toggleAutoAcceptOrder } from "../../../api/api";
import { set } from "react-hook-form";
import { IconButton } from "@mui/material";
import { FaBackspace } from "react-icons/fa";
import { FaAngleDown } from "react-icons/fa";
import { FaAngleUp } from "react-icons/fa";
import { Toaster, toast } from "react-hot-toast";

const AutoOrderSetting = ({ handleSettingSwitch }) => {
  //Configuration for paragraph
  const initialText =
    "This feature automatically accepts all customer orders 24/7, saving you time. Once an order is placed, it's moved to the 'In Progress' tab in the Order Manager. Before enabling this, make sure your inventory levels are accurate to prevent disappointing customers!";

  const [showFullText, setShowFullText] = useState(
    window.innerWidth > 768 // Show full text by default on larger screens
  );
  const [isMobileOrTablet, setIsMobileOrTablet] = useState(
    window.innerWidth <= 768
  );

  const handleToggleText = () => {
    setShowFullText(!showFullText);
  };

  const handleResize = () => {
    const isMobileOrTabletNow = window.innerWidth <= 768;
    setIsMobileOrTablet(isMobileOrTabletNow);

    // Adjust showFullText based on screen size change
    if (isMobileOrTablet !== isMobileOrTabletNow) {
      setShowFullText(!isMobileOrTabletNow);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [isMobileOrTablet]);

  //configuration for toggle state
  const value = JSON.parse(localStorage.getItem("autoAcceptsOrders"));

  const [acceptOrders, setAcceptOrders] = useState(value);
  const [loading, setLoading] = useState(false);
  const handleToggle = async () => {
    try {
      let targetValue = !acceptOrders;
      setLoading(true);
      const response = await toggleAutoAcceptOrder(
        JSON.stringify({
          value: targetValue,
        })
      );

      if (response) {
        setAcceptOrders(targetValue);
        localStorage.setItem("autoAcceptsOrders", targetValue);

        if (targetValue) {
          toast.success("Auto Accept Orders has been turned on.");
        } else {
          toast.success("Auto Accept Orders has been turned off.");
        }
      } else {
        console.error("API call failed");
      }
    } catch (error) {
      console.error("Error making API call", error);
      toast.error("Could not complete request");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="tabPanelCls h-100">
      <Toaster />
      <div
        className="dispatchTimer"
        style={{ position: "relative", marginTop: "20px" }}
      >
        <div
          style={{
            position: "fixed",
            width: "100%",
            background: "white",
            marginTop: "10px",
          }}
        >
          <div className="header">
            <div style={{ marginBottom: 20 }}>
              <h2 className="ruby center">
                <IconButton onClick={() => handleSettingSwitch("")}>
                  <FaBackspace />
                </IconButton>
                Auto Accept Orders
              </h2>
            </div>
            <p style={{ maxWidth: "70vw" }}>
              {showFullText ? initialText : `${initialText.slice(0, 100)}... `}
              {isMobileOrTablet && (
                <span
                  style={{
                    color: "grey",
                    cursor: "pointer",
                    marginLeft: 2,
                    display: "flex",
                    alignItems: "center",
                    gap: 4,
                    marginTop: 5,
                  }}
                  onClick={handleToggleText}
                >
                  {showFullText ? "Read less" : "Read more"}
                  {showFullText ? <FaAngleUp /> : <FaAngleDown />}
                </span>
              )}
            </p>
          </div>

          <FormGroup>
            <FormControlLabel
              control={
                loading ? (
                  <CircularProgress
                    style={{ marginRight: 10 }}
                    size={24}
                    color="secondary"
                  />
                ) : (
                  <Switch
                    color="success"
                    checked={acceptOrders}
                    onChange={handleToggle}
                  />
                )
              }
              label="Auto Accept Orders"
              style={{ marginLeft: 10, marginTop: 40 }}
            />
          </FormGroup>
        </div>
      </div>
    </div>
  );
};

export default AutoOrderSetting;
